export default __webpack_public_path__ + "img/15cd675a8ca5eee4dd8700eb87811e91.gif";